var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSoda(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#soda_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.063 14.18H31.745V5.137l10.817-1.643A1.758 1.758 0 1042.035.02l-12.31 1.87c-.86.13-1.495.868-1.495 1.737V14.18H15.937a5.28 5.28 0 00-5.273 5.274v3.515c0 .97.787 1.758 1.758 1.758h1.912l3.358 33.69c.09.899.846 1.583 1.75 1.583h21.105c.903 0 1.66-.685 1.75-1.584l3.346-33.689h1.935c.97 0 1.758-.787 1.758-1.758v-3.515a5.28 5.28 0 00-5.273-5.274zm-3.874 29.882H19.795l-.702-7.037h21.795l-.699 7.037zM21.033 56.484l-.888-8.907H39.84l-.885 8.907H21.033zm20.204-22.975H18.743l-.875-8.783H42.11l-.873 8.783zM45.82 21.21H14.18v-1.757c0-.97.788-1.758 1.758-1.758h28.124c.97 0 1.758.788 1.758 1.758v1.757z",
    fill: "#91C300"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "soda_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v60H0z"
  })))));
}

export default SvgSoda;